module.exports = __webpack_public_path__ + "28891aa40ee57ab27cb9623f88469b07.png";